import i18n from '@/i18n'
import Index from './index.vue'
import detail from './detail.vue'
import List from './list.vue'
import { TAB_CATEGORY } from '@/constant/permission'

const basePath = '/v-admin/talent-pool'

export default {
  name: 'talentFilterGroupListNew',
  path: `${basePath}`,
  component: Index,
  meta: {
    permission: TAB_CATEGORY.TALENT_POOL,
    isInclude: true,
    get title () {
      return i18n.t('admin.talent.pool.title')
    },
    tab: {
      get label () {
        return i18n.t('admin.talent.pool.tab')
      }
    }
  },
  children: [
    {
      name: 'talentGroupList',
      path: `${basePath}/group-list`,
      component: List,
      meta: {
        isInclude: true,
        titleI18nKey: 'admin.talent.pool.title'
      }
    },
    {
      name: 'talentApplicationList',
      path: `${basePath}/:talentFilterGroupId`,
      component: detail,
      meta: {
        isInclude: true,
        titleI18nKey: 'admin.talent.pool.title'
      }
    }
  ]
}
